/**
The main entry point for the account login.

Referenced by the customers/login.liquid template.

This script checks if a user has an access token cookie and refreshes the session if they do to keep them 'logged in'
* */
import { OV_ID_URL } from './config/theme';
import { getAccessToken } from './apps/customers/utils';

var init = function init() {
  var url = "".concat(OV_ID_URL, "users/login");

  if (getAccessToken()) {
    var urlParams = new URLSearchParams(window.location.search);
    var checkoutURL = urlParams.get('checkout_url') || false;
    var returnURL = urlParams.get('return_url') || false;
    var host = "".concat(window.location.protocol, "//").concat(window.location.host);
    var redirectTo = url; // If a checkout URL param is present, redirect there, otherwise head to the account

    if (checkoutURL) {
      redirectTo = checkoutURL;
    } else if (returnURL) {
      redirectTo = "".concat(host).concat(returnURL);
    }

    url = "".concat(OV_ID_URL, "users/refresh-shopify-session?redirectTo=").concat(redirectTo);
  }

  window.location.assign(url);
};

init();